export default {
  vendor_management: ['vendor_management'],
  vendor_add: ['vendor_add'],
  vendor_edit: ['vendor_edit'],
  vendor_status: ['vendor_edit'],
  vendor_detele: ['vendor_detele']
}
